"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var mithril_1 = tslib_1.__importDefault(require("mithril"));
var _1 = require("./");
var _2 = require("@/");
var logoSrc = require('../logo.svg');
var Main = /** @class */ (function () {
    function Main() {
        var _this = this;
        this.isDrawerOpen = false;
        this.closeDrawer = function () { return _this.isDrawerOpen = false; };
        this.handleLinkClick = function (e) {
            var contentEl = (0, _2.getClosest)(e.target, '.Docs-nav');
            _this.scrollPosition = contentEl.scrollTop;
        };
        this.handleDrawerOnOpened = function (el) {
            var contentEl = el.querySelector('.Docs-nav');
            contentEl.scrollTop = _this.scrollPosition;
        };
    }
    Main.prototype.view = function (_a) {
        var _this = this;
        var attrs = _a.attrs;
        var isMobile = _2.ResponsiveManager.is('xs') || _2.ResponsiveManager.is('sm');
        var logo = (0, mithril_1.default)('img.Docs-logo', { src: logoSrc });
        var nav = (0, _1.Nav)({
            data: attrs,
            closeDrawer: this.closeDrawer,
            logo: logo,
            isMobile: isMobile,
            onLinkClick: this.handleLinkClick
        });
        return (0, mithril_1.default)('.Docs', { class: isMobile ? 'is-mobile' : '' }, [
            isMobile && (0, mithril_1.default)('.Docs-mobile-header', [
                logo,
                (0, mithril_1.default)(_2.Button, {
                    basic: true,
                    iconLeft: _2.Icons.MENU,
                    label: 'Menu',
                    onclick: function () { return _this.isDrawerOpen = true; },
                    size: 'xs'
                })
            ]),
            isMobile
                ? (0, mithril_1.default)(_2.Drawer, {
                    class: 'Docs-nav-drawer',
                    isOpen: this.isDrawerOpen,
                    position: 'left',
                    content: nav,
                    onClose: this.closeDrawer,
                    onOpened: this.handleDrawerOnOpened
                })
                : nav,
            (0, mithril_1.default)('.Docs-container', (0, _1.Content)(tslib_1.__assign({}, attrs)))
        ]);
    };
    return Main;
}());
exports.default = Main;
